import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import QR from '../../assets/images/QR.jpeg';
import TitleText from './TitleText';
import BodyText from './BodyText';
import HeaderSection from './HeaderSection';
import Footer from '../../pages/Desktop/Footer';
const BankPage = () => {
	return (
		<>
			<HeaderSection />
			<Grid container spacing={4} style={{ padding: 100 }}>
				<Grid item xs={12} md={6} lg={4}>
					<TitleText
						four
						textStyle={{
							fontFamily: 'Josefin Sans, sans-serif',
							fontWeight: 500,
							fontSize: 18,
						}}>
						SBI BANK Detail
					</TitleText>
					<Box
						mt={'20px'}
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Bank Name:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							SBI BANK
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							A/c No:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							40854219954
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							IFSC code:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							SBIN0001641
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							AC/ Holder:
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							MUSAFIR BAZAR
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Branch :
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							ISM, DHANBAD
						</BodyText>
					</Box>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='space-between'>
						<TitleText three textStyle={{ fontSize: 16 }}>
							Account Type :
						</TitleText>
						<BodyText three textStyle={{ fontSize: 16 }}>
							CURRENT
						</BodyText>
					</Box>
					<Box mt={'20px'}>
						<TitleText
							four
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								fontSize: 18,
							}}>
							Axis Bank Detail
						</TitleText>
						<Box
							mt={'20px'}
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								Bank Name:
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								Axis Bank
							</BodyText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								A/c No:
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								916020007008157
							</BodyText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								IFSC code:
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								UTIB0000765
							</BodyText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								AC/ Holder:
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								E WEB BAZAR PRIVATE LIMITED
							</BodyText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								Branch :
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								City Center, Dhanbad
							</BodyText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'>
							<TitleText three textStyle={{ fontSize: 16 }}>
								Account Type :
							</TitleText>
							<BodyText three textStyle={{ fontSize: 16 }}>
								CURRENT
							</BodyText>
						</Box>
					</Box>
				</Grid>
				<Grid item xs={12} md={6} lg={2}></Grid>
				<Grid item xs={12} md={6} lg={4}>
					<TitleText
						four
						textStyle={{
							fontFamily: 'Josefin Sans, sans-serif',
							fontWeight: 500,
							fontSize: 18,
						}}>
						UPI
					</TitleText>
					<img src={QR} style={{ width: '100%' }} />
				</Grid>
			</Grid>
			<Footer />
		</>
	);
};

export default BankPage;
